import React, { useState, useEffect } from "react";
import { gameAPI } from "../services/api";
import "./Leaderboard.css";

const Leaderboard = ({ gameSlug }) => {
  const [leaderboard, setLeaderboard] = useState([]);
  const [timeframe, setTimeframe] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadLeaderboard();
  }, [timeframe, gameSlug]);

  const loadLeaderboard = async () => {
    try {
      setLoading(true);
      const response = await gameAPI.getLeaderboard(gameSlug, {
        timeframe,
        limit: 10,
      });
      setLeaderboard(response.data);
    } catch (error) {
      console.error("Error loading leaderboard:", error);
    } finally {
      setLoading(false);
    }
  };

  const getMedalEmoji = (rank) => {
    switch (rank) {
      case 0:
        return "🥇";
      case 1:
        return "🥈";
      case 2:
        return "🥉";
      default:
        return `#${rank + 1}`;
    }
  };

  return (
    <div className="leaderboard-container">
      <div className="leaderboard-header">
        <h2>🏆 Leaderboard</h2>
      </div>

      <div className="timeframe-selector">
        <button
          className={timeframe === "all" ? "active" : ""}
          onClick={() => setTimeframe("all")}
        >
          All Time
        </button>
        <button
          className={timeframe === "month" ? "active" : ""}
          onClick={() => setTimeframe("month")}
        >
          This Month
        </button>
        <button
          className={timeframe === "week" ? "active" : ""}
          onClick={() => setTimeframe("week")}
        >
          This Week
        </button>
        <button
          className={timeframe === "today" ? "active" : ""}
          onClick={() => setTimeframe("today")}
        >
          Today
        </button>
      </div>

      {loading ? (
        <div className="loading">Loading...</div>
      ) : (
        <div className="leaderboard-list">
          {leaderboard.length === 0 ? (
            <p className="no-scores">No scores yet. Be the first!</p>
          ) : (
            leaderboard.map((entry, index) => (
              <div
                key={entry.id}
                className={`leaderboard-entry rank-${index + 1}`}
              >
                <span className="rank">{getMedalEmoji(index)}</span>
                <div className="player-info">
                  <span className="player-name">{entry.player_name}</span>
                  <span className="company-name">{entry.company_name}</span>
                </div>
                <span className="score">{entry.score} pts</span>
              </div>
            ))
          )}
        </div>
      )}

      <div className="logo-watermark">
        <img
          src="/logo1.png"
          alt="Peach"
          onError={(e) => {
            e.target.style.display = "none";
          }}
        />
        <img
          src="/main-logo.svg"
          alt="Peach"
          onError={(e) => {
            e.target.style.display = "none";
          }}
        />
        <img
          src="/Wizzyl.png"
          alt="Peach"
          onError={(e) => {
            e.target.style.display = "none";
          }}
        />
      </div>
    </div>
  );
};

export default Leaderboard;
